import { Text, Colors, Icon } from '@doordash/design-language'
import styled from 'styled-components'
import { CloseButton, Root } from './styles'

import * as React from 'react'

const STRIPE_PREPEND_PATTERN = /Request\sreq_[\w]+:\s/

function formatMessage(error) {
  let err = error
  if (typeof error === 'object' && error.length > 0) {
    err = error[0]
  }
  if (error) {
    err = error.replace(STRIPE_PREPEND_PATTERN, '')
  }
  return err
}

export const TYPES = { ERROR: 'ERROR', SUCCESS: 'SUCCESS', INFO: 'INFO' }

const COLOR_MAP = {
  [TYPES.SUCCESS]: {
    foreground: Colors.SystemBlack,
    background: Colors.SystemTeal5,
    interactive: Colors.SystemTeal20,
  },
  [TYPES.ERROR]: {
    foreground: Colors.SystemRed80,
    background: Colors.SystemRed5,
    interactive: Colors.SystemRed20,
  },
  [TYPES.INFO]: {
    foreground: Colors.ButtonFlatSecondaryPressed,
    background: Colors.WarningBackground,
    interactive: Colors.ErrorText,
  },
}

type Props = {
  message: string | number
  onClose?: () => void
  type?: string
  marginTop?: string
}

const defaultProps: Props = {
  message: '',
  type: 'ERROR',
}

export const Notifier: React.SFC<Props> = ({
  message,
  onClose,
  type,
  marginTop,
}) => (
  <React.Fragment>
    {message && (
      <Root color={COLOR_MAP[type].background} marginTop={marginTop}>
        <Text styles={Text.Styles.Medium14} color={COLOR_MAP[type].foreground}>
          {formatMessage(message || '')}
        </Text>
        <CloseButton
          onClick={onClose}
          interactiveColor={COLOR_MAP[type].interactive}
        >
          <Icon
            type={Icon.Types.CloseCircleLine}
            color={Icon.Colors.SystemBlack}
            size={Icon.Sizes.Large}
          />
        </CloseButton>
      </Root>
    )}
  </React.Fragment>
)

export const NotifierWrapper = styled(Notifier)`
  padding-top: 60px;
`
Notifier.defaultProps = defaultProps

export default Notifier
